"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _lodash = _interopRequireDefault(require("lodash"));

var _axios = _interopRequireDefault(require("axios"));

var _basic = _interopRequireDefault(require("./_basic"));

var _basic_provider = _interopRequireWildcard(require("./_basic_provider"));

var ImportFrom =
/*#__PURE__*/
function (_BasicApi) {
  (0, _inherits2.default)(ImportFrom, _BasicApi);

  /**
   * @constructor
   */
  function ImportFrom(_ref) {
    var _this;

    var userTokenFactory = _ref.userTokenFactory,
        url = _ref.url;
    (0, _classCallCheck2.default)(this, ImportFrom);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ImportFrom).call(this, {
      userTokenFactory: userTokenFactory
    }));
    _this.url = url;
    return _this;
  }

  (0, _createClass2.default)(ImportFrom, [{
    key: "get",
    value: function () {
      var _get = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee() {
        var headers;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.getHeaders();

              case 2:
                headers = _context.sent;
                return _context.abrupt("return", _axios.default.get(this.url, headers));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function get() {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }]);
  return ImportFrom;
}(_basic.default);

var LibraryCategories =
/*#__PURE__*/
function (_BasicProviderApi) {
  (0, _inherits2.default)(LibraryCategories, _BasicProviderApi);

  function LibraryCategories() {
    (0, _classCallCheck2.default)(this, LibraryCategories);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(LibraryCategories).apply(this, arguments));
  }

  (0, _createClass2.default)(LibraryCategories, [{
    key: "getAllCategories",
    value: function () {
      var _getAllCategories = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2() {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._callApi({
                  method: 'get',
                  path: '/library-categories/import-export',
                  errorName: 'LibraryCategoriesError'
                });

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getAllCategories() {
        return _getAllCategories.apply(this, arguments);
      }

      return getAllCategories;
    }()
  }, {
    key: "setAllCategories",
    value: function () {
      var _setAllCategories = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(payload) {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._callApi({
                  method: 'post',
                  path: '/library-categories/import-export',
                  payload: payload,
                  errorName: 'LibraryCategoriesError'
                });

              case 2:
                return _context3.abrupt("return", _context3.sent);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function setAllCategories(_x) {
        return _setAllCategories.apply(this, arguments);
      }

      return setAllCategories;
    }()
  }, {
    key: "getCategories",
    value: function () {
      var _getCategories = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(categoryType) {
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this._callApi({
                  method: 'get',
                  path: '/library-categories',
                  queryParams: {
                    type: categoryType
                  },
                  errorData: {
                    categoryType: categoryType
                  },
                  errorName: 'LibraryCategoriesError'
                });

              case 2:
                return _context4.abrupt("return", _context4.sent);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getCategories(_x2) {
        return _getCategories.apply(this, arguments);
      }

      return getCategories;
    }()
  }, {
    key: "getCategory",
    value: function () {
      var _getCategory = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(categoryType, id) {
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._callApi({
                  method: 'get',
                  path: '/library-categories',
                  queryParams: {
                    type: categoryType,
                    id: id
                  },
                  errorData: {
                    categoryType: categoryType,
                    id: id
                  },
                  errorName: 'LibraryCategoriesError'
                });

              case 2:
                return _context5.abrupt("return", _context5.sent);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getCategory(_x3, _x4) {
        return _getCategory.apply(this, arguments);
      }

      return getCategory;
    }()
  }, {
    key: "addCategory",
    value: function () {
      var _addCategory = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6(categoryType, payload, id) {
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this._callApi({
                  method: 'post',
                  path: '/library-categories',
                  queryParams: {
                    type: categoryType,
                    id: id
                  },
                  payload: payload,
                  errorData: {
                    categoryType: categoryType,
                    id: id
                  },
                  errorName: 'LibraryCategoriesError'
                });

              case 2:
                return _context6.abrupt("return", _context6.sent);

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function addCategory(_x5, _x6, _x7) {
        return _addCategory.apply(this, arguments);
      }

      return addCategory;
    }()
  }, {
    key: "editCategory",
    value: function () {
      var _editCategory = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee7(categoryType, payload, id) {
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this._callApi({
                  method: 'put',
                  path: '/library-categories',
                  queryParams: {
                    type: categoryType,
                    id: id
                  },
                  payload: payload,
                  errorData: {
                    categoryType: categoryType,
                    id: id
                  },
                  errorName: 'LibraryCategoriesError'
                });

              case 2:
                return _context7.abrupt("return", _context7.sent);

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function editCategory(_x8, _x9, _x10) {
        return _editCategory.apply(this, arguments);
      }

      return editCategory;
    }()
  }, {
    key: "deleteCategory",
    value: function () {
      var _deleteCategory = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee8(categoryType, id) {
        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this._callApi({
                  method: 'delete',
                  path: '/library-categories',
                  queryParams: {
                    type: categoryType,
                    id: id
                  },
                  errorData: {
                    categoryType: categoryType,
                    id: id
                  },
                  errorName: 'LibraryCategoriesError'
                });

              case 2:
                return _context8.abrupt("return", _context8.sent);

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function deleteCategory(_x11, _x12) {
        return _deleteCategory.apply(this, arguments);
      }

      return deleteCategory;
    }()
  }, {
    key: "importAllCategories",
    value: function () {
      var _importAllCategories = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee9(url, token) {
        var importFrom, _ref2, data;

        return _regenerator.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                importFrom = new ImportFrom({
                  userTokenFactory: function userTokenFactory() {
                    return "USER ".concat(token);
                  },
                  url: url
                });
                _context9.prev = 1;
                _context9.next = 4;
                return importFrom.get();

              case 4:
                _ref2 = _context9.sent;
                data = _ref2.data;

                if (data.allCategories) {
                  _context9.next = 8;
                  break;
                }

                throw new Error('URL is not "library-categories/import-export" provider');

              case 8:
                _context9.next = 10;
                return this.setAllCategories(data);

              case 10:
                return _context9.abrupt("return", data);

              case 13:
                _context9.prev = 13;
                _context9.t0 = _context9["catch"](1);
                throw new _basic_provider.ProviderError(_context9.t0, {
                  statusCode: _lodash.default.get(_context9.t0, ['response', 'status']),
                  url: url
                }, 'importAllCategories');

              case 16:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[1, 13]]);
      }));

      function importAllCategories(_x13, _x14) {
        return _importAllCategories.apply(this, arguments);
      }

      return importAllCategories;
    }()
  }]);
  return LibraryCategories;
}(_basic_provider.default);

var _default = LibraryCategories;
exports.default = _default;